module.exports = __webpack_public_path__ + "static/media/vgpro.2cd9cfdd.png";